window.addEventListener('DOMContentLoaded', function () {
  const searchBlock = document.querySelectorAll('.filter-search');

  if (searchBlock) {
    const searchBtnShow = document.querySelectorAll('.filter-search__btn--show');
    const searchBtnClose = document.querySelectorAll('.filter-search__btn--close');

    searchBtnShow.forEach((item) => {
      item.addEventListener('click', () => {
        item.closest('.filter-search').classList.add('filter-search--show');
        item.closest('.filter-search').querySelector('input').focus();
      });
    });

    searchBtnClose.forEach((item) => {
      item.addEventListener('click', () => {
        item.closest('.filter-search').classList.remove('filter-search--show');
        item.closest('.filter-search').querySelector('input').blur();
      });
    });
  }
});
